import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'

type Props = {
  onSuccess?: () => void
}

type Data = {
  proposalId: string
  text: string
}

export const rejectProposal = async (data: Data): Promise<any> => {
  return axios.post(`/orders/proposals/${data.proposalId}/reject`, data)
}

export function useRejectProposal({ onSuccess }: Props) {
  const queryClient = useQueryClient()
  return useMutation(rejectProposal, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      toast.success('Orçamento rejeitado com sucesso!')
      onSuccess?.()
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível rejeitar o orçamento!')
    }
  })
}
